"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AppCapchaTemplatesListCtl = /** @class */ (function (_super) {
    __extends(AppCapchaTemplatesListCtl, _super);
    function AppCapchaTemplatesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_dir_name_select_to = UIUtils_1.UIUtils.IProp2Str(function (o) { o.dir_name_select_to; });
        _this.dk_dir_list_rubbish = UIUtils_1.UIUtils.IProp2Str(function (o) { o.dir_list_rubbish; });
        _this.dk_row_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.row_count; });
        _this.dk_col_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.col_count; });
        _this.dk_sel_count_min = UIUtils_1.UIUtils.IProp2Str(function (o) { o.sel_count_min; });
        _this.dk_sel_count_max = UIUtils_1.UIUtils.IProp2Str(function (o) { o.sel_count_max; });
        _this.dk_quest_text = UIUtils_1.UIUtils.IProp2Str(function (o) { o.quest_text; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    AppCapchaTemplatesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    AppCapchaTemplatesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "capcha template with id [" + id + "] not found !";
    };
    AppCapchaTemplatesListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListCapchaTemplatesGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    dir_name_select_to: resp.list[i].img_dir_name_select_to,
                    dir_list_rubbish: resp.list[i].img_dir_list_rubbish,
                    row_count: resp.list[i].row_count,
                    col_count: resp.list[i].col_count,
                    sel_count_min: resp.list[i].sel_count_min,
                    sel_count_max: resp.list[i].sel_count_max,
                    quest_text: resp.list[i].quest_text,
                    description: resp.list[i].description,
                    is_locked: resp.list[i].is_locked,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AppCapchaTemplatesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddCapchaTemplate.exec({
            data: {
                title: data.title,
                dir_name_select_to: data.dir_name_select_to,
                dir_list_rubbish: data.dir_list_rubbish,
                row_count: data.row_count,
                col_count: data.col_count,
                sel_count_min: data.sel_count_min,
                sel_count_max: data.sel_count_max,
                quest_text: data.quest_text,
                description: data.description,
                is_locked: data.is_locked
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                description: data.description,
                dir_name_select_to: data.dir_name_select_to,
                dir_list_rubbish: data.dir_list_rubbish,
                is_locked: data.is_locked,
                row_count: data.row_count,
                col_count: data.col_count,
                sel_count_min: data.sel_count_min,
                sel_count_max: data.sel_count_max,
                quest_text: data.quest_text
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AppCapchaTemplatesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditCapchaTemplate.exec({
                data: {
                    key_uid: data.key,
                    title: data.title,
                    description: data.description,
                    img_dir_name_select_to: data.dir_name_select_to,
                    img_dir_list_rubbish: data.dir_list_rubbish,
                    row_count: data.row_count,
                    col_count: data.col_count,
                    sel_count_min: data.sel_count_min,
                    sel_count_max: data.sel_count_max,
                    quest_text: data.quest_text,
                    is_locked: data.is_locked
                }
            }, function (resp) {
                _tmp.description = data.description;
                _tmp.title = data.title;
                _tmp.is_locked = data.is_locked;
                _tmp.dir_name_select_to = data.dir_name_select_to;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.dir_list_rubbish = data.dir_list_rubbish;
                _tmp.row_count = data.row_count;
                _tmp.col_count = data.col_count;
                _tmp.sel_count_min = data.sel_count_min;
                _tmp.sel_count_max = data.sel_count_max;
                _tmp.quest_text = data.quest_text;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AppCapchaTemplatesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AppCapchaTemplatesListCtl.prototype.DeleteDomain = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteCapchaTemplate.exec({ data: { capcha_tpl_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AppCapchaTemplatesListCtl.prototype.doSetIsLocked = function (key, isLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetCapchaTemplateIsLocked.exec({ data: { key_uid: key, is_locked: isLocked } }, function (resp) {
                _tmp.is_locked = isLocked;
                //_tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AppCapchaTemplatesListCtl.prototype.doGenerateImage = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoTestImageJoin.exec({ data: { capcha_tpl_id: key } }, function (resp) {
                //_tmp.is_locked = isLocked;
                //_tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AppCapchaTemplatesListCtl;
}(BaseController_1.BaseController));
exports.AppCapchaTemplatesListCtl = AppCapchaTemplatesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_capcha/ctl/AppCapchaTemplatesListCtl.ts
// module id = 1059
// module chunks = 0